var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/* eslint-disable @typescript-eslint/no-use-before-define */
import { Type } from 'class-transformer';
import { Column, Entity, Index, JoinColumn, ManyToOne, OneToMany, PrimaryColumn } from 'typeorm';
import { WebAnalysis } from './analysis.js';
import { BaseSnapshot } from './snapshot.js';
import { Test } from './test.js';
let HTTPSnapshot = class HTTPSnapshot extends BaseSnapshot {
    test;
    analyses;
    screenshot;
    trace;
    requests;
    deployment;
    sockets;
    pages;
    frames;
    transactions;
    wallet;
    console;
    data;
};
__decorate([
    ManyToOne(() => Test, (test) => test.id, { nullable: true, onDelete: 'CASCADE' }),
    __metadata("design:type", Test)
], HTTPSnapshot.prototype, "test", void 0);
__decorate([
    OneToMany(() => WebAnalysis, (a) => a.snapshot),
    __metadata("design:type", Array)
], HTTPSnapshot.prototype, "analyses", void 0);
__decorate([
    Column({ type: 'text', nullable: true }),
    __metadata("design:type", Object)
], HTTPSnapshot.prototype, "screenshot", void 0);
__decorate([
    Column({ type: 'text', nullable: true }),
    __metadata("design:type", Object)
], HTTPSnapshot.prototype, "trace", void 0);
__decorate([
    Type(() => HTTPTransaction),
    OneToMany(() => HTTPTransaction, (transaction) => transaction.snapshot, { onDelete: 'CASCADE' }),
    __metadata("design:type", Array)
], HTTPSnapshot.prototype, "requests", void 0);
__decorate([
    Column({ type: 'uuid', nullable: true }),
    __metadata("design:type", Object)
], HTTPSnapshot.prototype, "deployment", void 0);
__decorate([
    Column({ type: 'jsonb', nullable: true }),
    __metadata("design:type", Object)
], HTTPSnapshot.prototype, "sockets", void 0);
__decorate([
    Column({ type: 'jsonb', nullable: true }),
    __metadata("design:type", Object)
], HTTPSnapshot.prototype, "pages", void 0);
__decorate([
    Column({ type: 'jsonb', nullable: true }),
    __metadata("design:type", Object)
], HTTPSnapshot.prototype, "frames", void 0);
__decorate([
    Column({ type: 'jsonb', nullable: true }),
    __metadata("design:type", Object)
], HTTPSnapshot.prototype, "transactions", void 0);
__decorate([
    Column({ type: 'jsonb', nullable: true }),
    __metadata("design:type", Object)
], HTTPSnapshot.prototype, "wallet", void 0);
__decorate([
    Column({ type: 'jsonb', nullable: true }),
    __metadata("design:type", Object)
], HTTPSnapshot.prototype, "console", void 0);
__decorate([
    Column({ type: 'jsonb', nullable: true }),
    __metadata("design:type", Object)
], HTTPSnapshot.prototype, "data", void 0);
HTTPSnapshot = __decorate([
    Entity({ name: 'web_snapshots' }),
    Index('idx_web_project_test_updated', ['project', 'test', 'updatedDate']),
    Index('idx_web_snapshots_project_test_created', ['project', 'test', 'createdDate']),
    Index('idx_web_deployment', ['deployment'])
], HTTPSnapshot);
export { HTTPSnapshot };
let HTTPTransaction = class HTTPTransaction {
    id;
    // Transaction data:
    connection;
    snapshot;
    snapshotId;
    frame;
    page;
    initiator;
    source;
    type;
    // Request data:
    request_headers;
    request_url;
    request_origin; // e.g., 'https://example.com:3000'
    // Pathname is capped at 128 characters for indexability and bounded storage;
    // this fully covers ~99.81% of observed pathnames (full URL is preserved in request_url).
    request_pathname; // e.g., '/api/v1/resource'
    request_method;
    request_postData;
    request_integrityHash;
    // Response data:
    response_headers;
    response_contentType;
    response_status;
    response_sha256;
    response_size;
    // Body data:
    url;
};
__decorate([
    PrimaryColumn('uuid', { default: () => 'uuidv7()' }),
    __metadata("design:type", String)
], HTTPTransaction.prototype, "id", void 0);
__decorate([
    Column('jsonb'),
    __metadata("design:type", Object)
], HTTPTransaction.prototype, "connection", void 0);
__decorate([
    Type(() => HTTPSnapshot),
    ManyToOne(() => HTTPSnapshot, (snapshot) => snapshot.requests, {
        nullable: false,
        createForeignKeyConstraints: false
    }),
    JoinColumn({ name: 'snapshotId' }),
    __metadata("design:type", HTTPSnapshot)
], HTTPTransaction.prototype, "snapshot", void 0);
__decorate([
    Column('uuid'),
    __metadata("design:type", String)
], HTTPTransaction.prototype, "snapshotId", void 0);
__decorate([
    Column({ type: 'smallint', nullable: true }),
    __metadata("design:type", Object)
], HTTPTransaction.prototype, "frame", void 0);
__decorate([
    Column({ type: 'smallint', nullable: true }),
    __metadata("design:type", Object)
], HTTPTransaction.prototype, "page", void 0);
__decorate([
    Column({ type: 'smallint', nullable: true }),
    __metadata("design:type", Object)
], HTTPTransaction.prototype, "initiator", void 0);
__decorate([
    Column({ type: 'varchar', nullable: true }),
    __metadata("design:type", Object)
], HTTPTransaction.prototype, "source", void 0);
__decorate([
    Column({ type: 'varchar', default: 'unknown' }),
    __metadata("design:type", String)
], HTTPTransaction.prototype, "type", void 0);
__decorate([
    Column('jsonb'),
    __metadata("design:type", Array)
], HTTPTransaction.prototype, "request_headers", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], HTTPTransaction.prototype, "request_url", void 0);
__decorate([
    Column({ type: 'varchar' }),
    __metadata("design:type", String)
], HTTPTransaction.prototype, "request_origin", void 0);
__decorate([
    Column({ type: 'varchar', length: 128 }),
    __metadata("design:type", String)
], HTTPTransaction.prototype, "request_pathname", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], HTTPTransaction.prototype, "request_method", void 0);
__decorate([
    Column({ type: 'text', nullable: true }),
    __metadata("design:type", Object)
], HTTPTransaction.prototype, "request_postData", void 0);
__decorate([
    Column({ type: 'text', nullable: true }),
    __metadata("design:type", Object)
], HTTPTransaction.prototype, "request_integrityHash", void 0);
__decorate([
    Column('jsonb'),
    __metadata("design:type", Array)
], HTTPTransaction.prototype, "response_headers", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], HTTPTransaction.prototype, "response_contentType", void 0);
__decorate([
    Column({ type: 'smallint' }),
    __metadata("design:type", Number)
], HTTPTransaction.prototype, "response_status", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], HTTPTransaction.prototype, "response_sha256", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], HTTPTransaction.prototype, "response_size", void 0);
__decorate([
    Column({ type: 'text' }),
    __metadata("design:type", String)
], HTTPTransaction.prototype, "url", void 0);
HTTPTransaction = __decorate([
    Entity(),
    Index('idx_tx_snapshot_id_sha', ['snapshot', 'id', 'response_sha256']),
    Index('idx_tx_origin', ['request_origin']),
    Index('idx_tx_pathname', ['request_pathname']),
    Index('idx_tx_content_type', ['response_contentType'])
], HTTPTransaction);
export { HTTPTransaction };
//# sourceMappingURL=data:application/json;base64,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